<template>
  <div class="facebookauth2">
    <div v-if="!bindingErrorStatus" class="loadingWindowImg">
      <img src="../assets/img/loading.gif" alt="" />
    </div>
    <div v-if="bindingErrorStatus" class="loadingWindowText">
        <p>{{ $t("bindingErrorMessage") }}</p>
        <p :style="{textDecoration: 'underline', cursor: 'pointer'}" @click="$router.push('/')">{{ $t("returnHome") }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Router from "../router";
import { isUserAuthenticated } from "../store/modules/cart";
export default {
  name: "facebookauth2",
  data() {
    return {
      test: false,
      code: "",
    };
  },
  methods: {
    ...mapActions("auth", [
      "LoginRequest",
      "resetEmail",
      "sentVerificationCode",
      "resetPassword",
      "Auth2RequestToken",
    ]),
    ...mapMutations("auth", ["updateErrorMessage"]),
    initiateLogin() {
      if (this.code) {

        if (this.isApp) {
          const code = this.code
          this.uni.postMessage({
            data: {
              action: 'facebookAuthSuccess',
              params: {
                code
              }
            }
          })
        }

        this.Auth2RequestToken({ token: this.code, type: "Facebook" });
        // store.dispatch('auth/fetchCustomerInformation', this.code);
      }
    },
  },
  //   beforeRouteLeave(to, from, next) {
  //     if (isUserAuthenticated()) {
  //       this.$store.dispatch("cart/getCart");
  //       this.$store.dispatch("auth/fetchCustomerInformation");
  //     } else {
  //       // this.$store.dispatch("cart/fetchCartProducts");
  //       // this.$store.dispatch("auth/fetchCustomerInformation");
  //     }
  //     next();
  //   },
  mounted() {
    this.code = this.$route.query.code;
    this.initiateLogin();

    //   this.$route.query
    //   '$route.query': {
    //   immediate: true,
    //   handler(newVal) {
    //     this.fetchProductDetails(newVal.productNum);
    //     this.updateActiveProduct(newVal.productNum);
    //     this.$store.dispatch('products/fetchCustomCategories');
    //     this.initializeTabImg();
    //     this.currentURL = 'https://gvyummy.com' + this.$route.fullPath;
    //   }
    // },
  },
  watch: {
    $route(to, from) {
      if (to.path === "/facebook-auth2") {
        this.code = this.$route.query.code;
        this.initiateLogin();
      }
    },
    // loginModalVisibilityGlobal: function(newVal, oldVal) {
    //     this.resetLoginForm();
    //     this.resetForgetPassword();
    // },
    // loggedIn: function(newVal, oldVal) {
    //     if (newVal === true) {
    //         this.toggleLoginModalVisibility(false);
    //     }
    // },
  },
  computed: mapState({
    loginModalVisibilityGlobal: (state) =>
      state.navbar.loginModalVisibilityGlobal,
    loggedIn: (state) => state.auth.loggedIn,
    bindingErrorStatus: (state) => state.auth.bindingErrorStatus,
  }),
};
</script>
​
​
<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/facebookauth2";
</style>



// WEBPACK FOOTER //
// src/view/facebookauth2.vue